<p-tag
  styleClass="sana-tag"
  [value]="status | therapyPlanStatusTranslations"
  [severity]="getSeverity(status)"
  [rounded]="true"></p-tag>
